import React from "react";
import { CircularProgress } from "@mui/material";
import { Styled } from "./styles";
import CampaignsList from "@/components/campaigns/list";
import useQueryCampaigns from "@/hooks/queries/useQueryCampaigns";

const Campaigns: React.FC = () => {
    const { data, isLoading } = useQueryCampaigns();

    if (isLoading) {
        return (
            <Styled.Container>
                <CircularProgress />
            </Styled.Container>
        );
    }

    if (!data) {
        return null;
    }

    return (
        <Styled.Container>
            <CampaignsList data={data} />
        </Styled.Container>
    );
};

export default Campaigns;
